const TabComp = ({ tabsData }) => {
  return (
      <div
        className="row px-4 row-cols-1 row-cols-sm-2 row-cols-lg-4 justify-content-end align-content-center"
        style={{ gap: "20px" }}
      >
        {tabsData?.map((data) => (
          <div
            className="card shadow-sm text-center border-0 flex-grow-1"
            key={data.ticketStatus}
          >
            <div className="card-body" style={{ padding: "36px" }}>
              <p className="text-dark my-auto mb-4 h1 fw-bold">
                {data?.length ? data?.length : 0}
              </p>
              <h5 className="card-title">{data.ticketStatus}</h5>
            </div>
          </div>
        )) ||
          [1, 2, 3].map((data) => (
            <div
              className="card shadow-sm text-center border-0 flex-grow-1"
              key={data}
            >
              <div className="card-body" style={{ padding: "36px" }}>
                <p className="text-dark my-auto mb-4 h1 fw-bold">0</p>
                <h5 className="card-title">{"-"}</h5>
              </div>
            </div>
          ))}
      </div>
  );
};

export default TabComp;
